var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 191,
    viewBox: "0 0 236 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M174.467 67.8233C173.041 67.8233 171.614 67.8709 170.235 67.9661C165.48 40.456 141.514 19.4665 112.649 19.4665C99.4299 19.4665 87.2565 23.8453 77.5083 31.2225C66.9517 12.6128 46.9322 0 23.9645 0C-10.0354 0 -37.5681 27.5577 -37.5681 61.5883C-37.5681 63.7301 -37.473 65.8719 -37.2352 67.9661C-38.6143 67.8709 -40.0408 67.8233 -41.4674 67.8233C-75.4673 67.8233 -103 95.381 -103 129.412C-103 163.442 -75.4673 191 -41.4674 191H174.467C208.467 191 236 163.442 236 129.412C236 95.381 208.467 67.8233 174.467 67.8233Z",
    fill: "#C8C5C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9294 13.6599C43.2232 11.8512 37.1365 10.8517 30.8596 10.8517C-1.95147 10.8517 -28.5332 37.4575 -28.5332 70.2983C-28.5332 72.3925 -28.4381 74.4391 -28.2003 76.4381C-29.5318 76.3429 -30.9108 76.2953 -32.2898 76.2953C-65.1009 76.2953 -91.6826 102.901 -91.6826 135.742C-91.6826 146.498 -88.8294 156.636 -83.7889 165.346C-86.0714 138.55 -81.9819 87.3374 -17.7864 88.5749C-18.4521 71.0598 -15.3137 16.1824 48.9294 13.6599Z",
    fill: "#4C4C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.6997 191H174.467C208.467 191 236 163.442 236 129.412C236 122.13 234.716 115.181 232.434 108.708C191.967 188.477 55.1588 181.386 -11.6997 191Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/cloud1.d9289c9778ba3f798362c423953e6255.svg";
export { ForwardRef as ReactComponent };